import { COLORS } from '@nzassa/shared';

interface BrandHeaderProps {
  schoolName?: string;
  schoolLogoUrl?: string;
}

export function BrandHeader({ schoolName, schoolLogoUrl }: BrandHeaderProps) {
  return (
    <div className="w-full border-b border-slate-200/60 bg-white">
      {/* Orange accent bar */}
      <div className="h-0.5" style={{ background: COLORS.orange }} />
      <div className="mx-auto max-w-6xl flex items-center justify-between px-4 py-2">
        {/* Left: ANSUT logo */}
        <div className="flex items-center gap-3">
          <img src="/logos/ansut.svg" alt="ANSUT" className="h-8" />
          <div className="h-6 w-px bg-slate-200" />
          <img src="/logos/nzassalearn.svg" alt="NzassaLearn" className="h-7" />
        </div>

        {/* Right: School name if present */}
        {schoolName && (
          <div className="flex items-center gap-2 text-xs text-slate-500">
            {schoolLogoUrl && <img src={schoolLogoUrl} alt={schoolName} className="h-6 w-6 rounded" />}
            <span className="font-medium">{schoolName}</span>
          </div>
        )}
      </div>
    </div>
  );
}
